import Style from './style'
import close from './asset/close.svg'

const DefaultModal = ({children, title, closeEvent, upper}) => {
	return (
		<Style.ModalBackground $upper={upper}>
			<Style.Modal>
				{title && (
					<Style.TitleDiv>
						<h2>{title}</h2>
						<button onClick={closeEvent}>
							<img src={close} />
						</button>
					</Style.TitleDiv>
				)}
				{children}
			</Style.Modal>
		</Style.ModalBackground>
	)
}

export default DefaultModal
